export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf02-de.3aca3465.png";